import React, { useContext, useMemo, useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Loader from '../components/common/loader'
import SmartBanner from 'react-smartbanner'
import 'react-smartbanner/dist/main.css'
import {
    getMobileOS,
    getSmartBannerClosedValue,
} from '../utils/helper-functions'
import { GlobalContext } from '../providers/contexts/Global'
import { useMediaQuery } from '@mui/material'

const Layout = React.lazy(() => import('../containers/Layout'))

export const Router = () => {
    const { user } = useContext(GlobalContext)
    const mobileMedia = useMediaQuery('(max-width:1024px)')
    const [isSmartBannerClose, setIsSmartBannerClose] = useState<boolean>(false)

    const mobileOS = useMemo(() => {
        return getMobileOS()
    }, [])

    useEffect(() => {
        const getBannerIsClosed = getSmartBannerClosedValue()
        if (!mobileMedia || getBannerIsClosed || !user.id)
            document.documentElement.style.setProperty('margin-bottom', `0px`)
        else document.documentElement.style.setProperty('margin-bottom', `80px`)
    }, [mobileMedia, isSmartBannerClose, user])
    return (
        <BrowserRouter>
            {mobileOS && user.id && (
                <div className="hide-desktop">
                    <SmartBanner
                        title="MWH: Fitness + Wellness"
                        description="Access 500+ classes &amp; more"
                        position="bottom"
                        force={mobileOS}
                        daysHidden={3}
                        daysReminder={3}
                        price={{
                            ios: 'Access 500+ classes & more',
                            android: 'Access 500+ classes & more',
                        }}
                        onClose={() => setIsSmartBannerClose(true)}
                    />
                </div>
            )}
            <React.Suspense fallback={<Loader />}>
                <Routes>
                    <Route path="*" element={<Layout />} />
                </Routes>
            </React.Suspense>
        </BrowserRouter>
    )
}
